import {
    KUBE_PODS_REQUEST_GET,
    KUBE_PODS_RESPONSE_GET_SUCCESS,
    KUBE_PODS_RESPONSE_GET_FAIL,

  } from "../../../constants/maintenance/systemHealth/kubePodsConstants";
  
  export const kubePodsShReducer = (state = { kubePods: {} }, action) => {
    switch (action.type) {
      case KUBE_PODS_REQUEST_GET:
        return {
          ...state,
          loading: true,
        };
      case KUBE_PODS_RESPONSE_GET_SUCCESS:
        return {
          ...state,
          loading: false,
          kubePods: action.payload,
        };
      case KUBE_PODS_RESPONSE_GET_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  